export default "__VITE_ASSET__C0KK5CyM__"